import * as React from 'react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import WrappedVideo from '../WrappedVideo/WrappedVideo.esm.js';
import '../WrappedVideo/NvVideo/NvVideo.esm.js';
import NvVimeo from '../WrappedVideo/Vimeo/Vimeo.esm.js';

var Media = function (_a) {
    var image = _a.image, vimeoId = _a.vimeoId, videoFields = _a.videoFields, alt = _a.alt;
    if (vimeoId) {
        return React.createElement(NvVimeo, { vimeoId: vimeoId });
    }
    if (videoFields) {
        return React.createElement(WrappedVideo, { fields: videoFields, id: "" });
    }
    if (image) {
        return React.createElement(BaseNucleobaseComponent, { alt: alt, source: image });
    }
    return null;
};

export { Media };
//# sourceMappingURL=Media.esm.js.map
